var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQrCode2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 149,
    viewBox: "0 0 151 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.1765,
    y: 32.3345,
    width: 20.9466,
    height: 20.9925,
    rx: 10.4733,
    fill: "black",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 86.8483,
    y: 25.2969,
    width: 14.8015,
    height: 14.8346,
    rx: 7.40076,
    fill: "black",
    stroke: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 56.123,
    y: 132.5,
    width: 13.9549,
    height: 13.9237,
    rx: 6.96183,
    transform: "rotate(-90 56.123 132.5)",
    fill: "black",
    stroke: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19.2528,
    y: 132.5,
    width: 13.9549,
    height: 13.9237,
    rx: 6.96183,
    transform: "rotate(-90 19.2528 132.5)",
    fill: "black",
    stroke: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 118.451,
    y: 41.1316,
    width: 13.9237,
    height: 13.9549,
    rx: 6.96183,
    fill: "black",
    stroke: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 71.0468,
    y: 101.71,
    width: 13.9549,
    height: 14.8015,
    rx: 6.97744,
    transform: "rotate(-90 71.0468 101.71)",
    fill: "black",
    stroke: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 102.65,
    y: 41.1316,
    width: 14.8015,
    height: 13.9549,
    rx: 6.97744,
    fill: "black",
    stroke: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 71.0468,
    y: 117.545,
    width: 14.8346,
    height: 14.8015,
    rx: 7.40076,
    transform: "rotate(-90 71.0468 117.545)",
    fill: "black",
    stroke: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 86.8483,
    y: 71.9212,
    width: 14.8015,
    height: 14.8346,
    rx: 7.40076,
    fill: "black",
    stroke: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 102.65,
    y: 132.5,
    width: 13.9549,
    height: 14.8015,
    rx: 6.97744,
    transform: "rotate(-90 102.65 132.5)",
    fill: "black",
    stroke: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 18.375,
    y: 101.71,
    width: 13.9549,
    height: 14.8015,
    rx: 6.97744,
    transform: "rotate(-90 18.375 101.71)",
    fill: "black",
    stroke: "black"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 102.65,
    y: 56.0864,
    width: 14.8015,
    height: 14.8346,
    rx: 7.40076,
    fill: "black",
    stroke: "black"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 86.8483,
    y: 117.545,
    width: 14.8346,
    height: 14.8015,
    rx: 7.40076,
    transform: "rotate(-90 86.8483 117.545)",
    fill: "black",
    stroke: "black"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 86.8483,
    y: 87.7556,
    width: 14.8015,
    height: 13.9549,
    rx: 6.97744,
    fill: "black",
    stroke: "black"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 118.451,
    y: 132.5,
    width: 13.9549,
    height: 13.9237,
    rx: 6.96183,
    transform: "rotate(-90 118.451 132.5)",
    fill: "black",
    stroke: "black"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 34.1765,
    y: 101.71,
    width: 13.9549,
    height: 13.9237,
    rx: 6.96183,
    transform: "rotate(-90 34.1765 101.71)",
    fill: "black",
    stroke: "black"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 22.875,
    y: 21,
    width: 43.5496,
    height: 43.6617,
    rx: 21.7748,
    stroke: "black",
    strokeWidth: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrCode2);
export default __webpack_public_path__ + "static/media/qr-code-2.a59890fa8f481ee00d343e77c78bb717.svg";
export { ForwardRef as ReactComponent };